/**
 * Prefills the contact form with product context from ?product=handle
 * (used by custom-order product CTAs). Shows a thumbnail card and seeds the message.
 */
(function () {
  const STORAGE_KEY = 'contactProductHandle';
  const form = document.getElementById('ContactForm');
  if (!form) return;

  const productCard = document.getElementById('ContactForm-product');
  const productImage = document.getElementById('ContactForm-product-image');
  const productTitle = document.getElementById('ContactForm-product-title');
  const productField = document.getElementById('ContactForm-product-field');
  const bodyField = document.getElementById('ContactForm-body');
  const subjectField = document.getElementById('ContactForm-subject');
  const successMessage = form.querySelector('.page-contact__message--success');

  if (successMessage) {
    sessionStorage.removeItem(STORAGE_KEY);
    return;
  }

  const params = new URLSearchParams(window.location.search);
  let handle = params.get('product');
  const shouldRestore = Boolean(document.getElementById('ContactForm-restore-product'));

  // Only show product context when arriving from a product CTA (?product=),
  // or when restoring after a failed submit. Main-menu Contact clears it.
  if (handle) {
    sessionStorage.setItem(STORAGE_KEY, handle);
  } else if (shouldRestore) {
    handle = sessionStorage.getItem(STORAGE_KEY);
  } else {
    sessionStorage.removeItem(STORAGE_KEY);
    return;
  }

  if (!handle) return;

  fetch(`/products/${encodeURIComponent(handle)}.js`)
    .then((response) => {
      if (!response.ok) throw new Error('Product not found');
      return response.json();
    })
    .then((product) => {
      const productUrl = product.url || `/products/${product.handle}`;
      const absoluteUrl = new URL(productUrl, window.location.origin).href;
      const imageSrc = product.featured_image
        ? product.featured_image.replace(/(\.[^.]+)$/, '_200x200$1')
        : '';

      if (productCard) {
        productCard.hidden = false;
      }

      if (productImage) {
        if (imageSrc) {
          productImage.src = imageSrc;
          productImage.alt = product.title || '';
          productImage.hidden = false;
        } else {
          productImage.hidden = true;
        }
      }

      if (productTitle) {
        productTitle.textContent = product.title;
        productTitle.href = productUrl;
      }

      if (productField) {
        productField.value = `${product.title} (${absoluteUrl})`;
      }

      if (subjectField && !subjectField.value) {
        const customOrderOption = Array.from(subjectField.options).find(
          (option) => option.value === 'Custom order'
        );
        if (customOrderOption) {
          subjectField.value = 'Custom order';
        }
      }

      if (bodyField && !bodyField.value.trim()) {
        bodyField.value = `Hi — I'm inquiring about ${product.title}.\n${absoluteUrl}\n\n`;
      }
    })
    .catch(() => {
      sessionStorage.removeItem(STORAGE_KEY);
    });
})();
